import React, { useState, useEffect } from 'react';
import { Dialog } from '@mui/material';
import { addApproverLevel } from '../../../../redux/dashboardSlice';
import InputField from '../../../../Components/Input';
import CustomButton from '../../../../Components/CustomButton';

interface AddApproverLevelModalProps {
  open: boolean;
  onClose: () => void;
  onSuccess?: (newJobTitle?: string) => void;
  productionId?: string | null;
  levelIndex?: number;
}

const AddApproverLevelModal = ({
  open,
  onClose,
  onSuccess,
  productionId,
  levelIndex,
}: AddApproverLevelModalProps): React.ReactElement => {
  const [comment, setComment] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const MAX_LENGTH = 50;

  const payload = {
    roleName: comment,
    productionId,
    levelIndex,
  };

  useEffect(() => {
    if (open) {
      setComment('');
    }
  }, [open]);

  const handleSave = (): void => {
    if (!comment.trim()) return;
    setIsSubmitting(true);

    addApproverLevel(
      payload,
      (): void => {
        setIsSubmitting(false);
        const newApproverLevel = comment;
        onClose();
        onSuccess?.(newApproverLevel);
      },
      (): void => {
        setIsSubmitting(false);
      },
    );
  };

  return (
    <Dialog
      open={open}
      onClose={(): void => onClose()}
      maxWidth="xs"
      fullWidth
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <div className="modal-dialog sm approver-level-modal">
        <div className="modal-content">
          <div className="modal-body pt-15 pb-15 pr-5 pl-5">
            <div className="">
              <p className="MuiTypography-body1 text-gray_700 fw500 text-center mb-8">
                Add Approval Level
              </p>
              <p className="MuiTypography-body2 text-text text-center mb-16 lh-14">
                Please name the approval level
              </p>
              <div className="form-in lg">
                <InputField
                  id="approvalLevel"
                  name="approvalLevel"
                  placeholder="Add Approval Level"
                  value={comment}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>): void =>
                    setComment(e.target.value)
                  }
                  disabled={isSubmitting}
                  error={comment.length > MAX_LENGTH}
                  helperText={
                    comment.length > MAX_LENGTH
                      ? 'Role Name length must be less than or equal to 50 characters'
                      : `${comment.length}/${MAX_LENGTH}`
                  }
                />
              </div>
            </div>
            <div className="modal-actions full">
              <div>
                <CustomButton
                  variant="outlined"
                  onClick={(): void => onClose()}
                  size="large"
                  text={'Cancel'}
                  showIcon={false}
                  id={''}
                />
              </div>
              <div>
                <CustomButton
                  variant="contained"
                  onClick={(): void => handleSave()}
                  disabled={
                    !comment.trim() ||
                    comment.length > MAX_LENGTH ||
                    isSubmitting
                  }
                  size="large"
                  text={isSubmitting ? 'Adding...' : 'Add'}
                  showIcon={false}
                  id={''}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </Dialog>
  );
};

export default AddApproverLevelModal;
